/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-file': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M15.414 1L21 6.586V21a2 2 0 01-2 2H5a2 2 0 01-2-2V3a2 2 0 012-2h10.414zM13 3H5v18h14V9h-4a2 2 0 01-2-2V3zm5.586 4L15 3.415V7h3.586z" _fill="#7E8994" fill-rule="evenodd"/>'
  }
})
